import { Injectable } from "@angular/core";
import { TranslateObject } from "../../views-interfaces//translate-object.interface";
import * as deliveryMethods_json from "src/assets/DeliveryMethods/DeliveryMethods.json";
import { IDashboardModel } from "src/app/views-interfaces/dashboard-model.interface";

@Injectable({
    providedIn: "root",
})
export class DeliveryMethodsService {
    public static readonly NONE_DELIVERY_METHOD_ID = "10";
    public static readonly CD_ROM_DELIVERY_METHOD_ID = "7";
    public deliveryMethods: Record<string, TranslateObject>;
    public deliveryMethods2023AndUp: Record<string, TranslateObject>;
    public deliveryMethodsForFilters: Record<string, TranslateObject>;
    public deliveryMethodsForFilters2023AndUp: Record<string, TranslateObject>;

    constructor() {
        this.deliveryMethods = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter((o) => o[0] !== "default" && o[0] !== DeliveryMethodsService.NONE_DELIVERY_METHOD_ID) // Exclude "None" option for card display
                .map((o) => [o[0], o[1] as TranslateObject]),
        );
        // Remove CD-ROM and "None" option for card display
        this.deliveryMethods2023AndUp = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter(
                    (o) =>
                        o[0] !== "default" &&
                        o[0] !== DeliveryMethodsService.CD_ROM_DELIVERY_METHOD_ID &&
                        o[0] !== DeliveryMethodsService.NONE_DELIVERY_METHOD_ID,
                )
                .map((o) => [o[0], o[1] as TranslateObject]),
        );

        this.deliveryMethodsForFilters = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter((o) => o[0] !== "default")
                .map((o) => [o[0], o[1] as TranslateObject]),
        );
        // For filters 2023 and up - include "None" option but exclude CD-ROM
        this.deliveryMethodsForFilters2023AndUp = Object.fromEntries(
            Object.entries(deliveryMethods_json)
                .filter((o) => o[0] !== "default" && o[0] !== DeliveryMethodsService.CD_ROM_DELIVERY_METHOD_ID)
                .map((o) => [o[0], o[1] as TranslateObject]),
        );
    }

    getDeliveryMethodsList(dashboard: IDashboardModel) {
        return dashboard.TaxYear >= 2023 ? this.deliveryMethods2023AndUp : this.deliveryMethods;
    }

    getDeliveryMethodsListForFilters(dashboard: IDashboardModel) {
        return dashboard.TaxYear >= 2023 ? this.deliveryMethodsForFilters2023AndUp : this.deliveryMethodsForFilters;
    }
}
